import { CashMovementDetailResponse } from '@repo/accounts-types'
import { GenericOperationState } from '@repo/core'
import { RootState } from '../../../../store/types'

export const cashMovementDetailSelectorConfig = {
  cashMovementDetailSelector: {
    getRootPath: function (
      state: RootState,
    ): GenericOperationState<CashMovementDetailResponse | null> {
      return state.accounts.detail.read.cashMovement.detail
    },
  },
}
